/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { IOverviewData, IOverviewLoaders } from '@midas/shared/common';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as OverviewStatisticsActions from './overview-statistics.actions';

export const OVERVIEW_STATISTICS_KEY = 'overviewStatistics';

export interface IOverviewStatisticsState {
  overview: IOverviewData;
  loaders: IOverviewLoaders;
}

const initialState: IOverviewStatisticsState = {
  overview: {
    numberOfWasteData: null,
    wasteByPersonData: null,
    wasteByDrugData: null,
    numberOfWitnessData: null,
    wasteByHospitalData: null,
    numberOfWitnessByHospitalData: null,
    rxInterceptWasteData: null,
    numberOfStandardWasteData: null,
    standardWasteLocationData: null,
    rxInterceptWasteByDateRangeData: null, 
  },
  loaders: {
    wasteByPersonLoader: false,
    numberOfWasteLoader: false,
    wasteByDrugLoader: false,
    numberOfWitnessLoader: false,
    wasteByHospitalLoader: false,
    numberOfWitnessByHospitalLoader: false,
    rxInterceptWasteLoader: false,
    numberOfStandardWasteLoader: false, 
    standardWasteLocationLoader: false,
    rxInterceptWasteByDateRangeLoader: false
  }
};

export const OverviewStatisticsFeature = createFeature({
  name: OVERVIEW_STATISTICS_KEY,
  reducer: createReducer(
    initialState,
    on(OverviewStatisticsActions.queryWasteByPerson, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, wasteByPersonLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryWasteByPersonSuccess, (state, { waste }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, wasteByPersonData: waste},
        loaders: {...state.loaders, wasteByPersonLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWaste, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, numberOfWasteLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWasteSuccess, (state, { data }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, numberOfWasteData: data.amountOfWaste},
        loaders: {...state.loaders, numberOfWasteLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryWasteByDrug, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, wasteByDrugLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryWasteByDrugSuccess, (state, { waste }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, wasteByDrugData: waste},
        loaders: {...state.loaders, wasteByDrugLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWitness, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, numberOfWitnessLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWitnessSuccess, (state, { data }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, numberOfWitnessData: data.amountOfWaste},
        loaders: {...state.loaders, numberOfWitnessLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWasteByHospital, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, wasteByHospitalLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWasteByHopitalSuccess, (state, { items }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, wasteByHospitalData: items},
        loaders: {...state.loaders, wasteByHospitalLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWitnessByHospital, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, numberOfWitnessByHospitalLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfWitnessByHospitalSuccess, (state, { items }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, numberOfWitnessByHospitalData: items},
        loaders: {...state.loaders, numberOfWitnessByHospitalLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryRxInterceptWaste, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, rxInterceptWasteLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryRxInterceptWasteSuccess, (state, { items }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, rxInterceptWasteData: items},
        loaders: {...state.loaders, rxInterceptWasteLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfStandardWaste, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, numberOfStandardWasteLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryNumberOfStandardWasteSuccess, (state, { data }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, numberOfStandardWasteData: data.amountOfWaste},
        loaders: {...state.loaders, numberOfStandardWasteLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryRxInterceptWasteByDateRange, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, rxInterceptWasteByDateRangeLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryRxInterceptWasteByDateRangeSuccess, (state, { data }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, rxInterceptWasteByDateRangeData: data.amountOfWaste},
        loaders: {...state.loaders, rxInterceptWasteByDateRangeLoader: true},
      };
    }),
    on(OverviewStatisticsActions.queryStandardWasteLocation, (state): IOverviewStatisticsState => {
      return {
        ...state,
        loaders: {...state.loaders, standardWasteLocationLoader: false},
      };
    }),
    on(OverviewStatisticsActions.queryStandardWasteLocationSuccess, (state, { count, items }): IOverviewStatisticsState => {
      return {
        ...state,
        overview: {...state.overview, standardWasteLocationData: items},
        loaders: {...state.loaders, standardWasteLocationLoader: true},
      };
    }),
  ),
});
